import React, { Component } from 'react';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG} from '../common/redux/constantes';
// import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CompletionDialog  from './CompletionDialog';
import{  ROLE_VIEWER,STATUS_PROJECT_PUBLISHED } from '../common/redux/constantes';
import DownloadCsv from "../common/DownloadCsv"



class Completion extends Component {
  static propTypes = {

  };


  state ={
    openCompletionDialog:false,
    workpackages:[]
  }

  constructor(props) {
    super(props);
    // this.tableRef = React.createRef();
    //Bindings
    this.fetchWorkpackages = this.fetchWorkpackages.bind(this);
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
  }


  componentDidMount()
  {
    this.fetchWorkpackages();
  }

  setDownloadInfo=(info)=>
  {
    info = JSON.parse(JSON.stringify(info))
    info=info.map(row=>{
      row.completed=row.status===1? "Completed":"Uncompleted"
      return row
    })
    let value={ data:info, 
             headers:[
             {label:"Control Account", key:"ca_name"},
             {label:"Deliverable", key:"deliverable_name"},
             {label:"Work Package", key:"name"},
             {label:"Completed", key:"completed"},
             {label:"Completion Date", key:"completion_date"},
             {label:"Due Date", key:"max_date"},
             ],
             tableName:"Deliverables", 
             lookupTable:[],
             type:7
           }
     this.setState({
       tableData:value
     })
   }

  fetchWorkpackages()
  {
    let self = this;
    let url = SERVER_PATH + '/workpackages/completion/' + this.props.project;
    fetch(url,AXIOS_CONFIG())
    .then(response => response.json())
    .then(result => {

      self.setDownloadInfo(result.workpackages)
      this.setState({workpackages:result.workpackages});
    });
  }

  handleClickOpen = (workpackage) => {
    let action = 1; // 1 Crear 2 Editar
    //Si el workpackage ya esta completado solo modifica la fecha
    if(workpackage.workpackage_status === 2)
    {
      action = 2;
    }
    this.setState({ openCompletionDialog: true,action:action,workpackageSelected:workpackage.workpackage});
  };

  handleClose = () => {
    this.setState({ openCompletionDialog: false });
    this.refreshTable();
  };

  refreshTable=()=>
  {
    // this.tableRef.current && this.tableRef.current.onQueryChange()
    this.fetchWorkpackages();
  }

  render() {
    let actionButtons = [
        rowData => ({
          icon: rowData.workpackage_status===3?'':'swap_horiz',
          tooltip: rowData.workpackage_status===3?'':'Update Workpackage',
          onClick: (event, rowData) => this.handleClickOpen(rowData),
          disabled: rowData.workpackage_status=== 3
        }),{
          icon: 'refresh',
          tooltip: 'Refresh Data',
          isFreeAction: true,
          onClick: () => this.fetchWorkpackages()//this.tableRef.current && this.tableRef.current.onQueryChange()
        }
        ,
        {
            icon: 'save',
            tooltip: 'Save Data',
            isFreeAction: true,
            onClick: () => 
            {
              this.childref.downloadData()
            }
        }
    ];
    if(Number(localStorage.getItem("role"))===ROLE_VIEWER || this.props.project_status !==STATUS_PROJECT_PUBLISHED)
    {
      actionButtons.splice(0,1);
    }


    return (
      <div className="summary-generic-cost">
          <MaterialTable
          onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
          options={{
            actionsColumnIndex:7,
            paging:false,
            search:false,
            // sorting:false,
            maxBodyHeight:"600px",
            headerStyle: {
              backgroundColor: '#FFF',
              color: '#000',
              fontSize:'1.05em'
            },
            rowStyle: (rowData) => {
                return {
                backgroundColor: 
                    (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                    '#EEE' 
                    :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                }
            }
          }}
          title="Deliverables"
          columns={[
            { 
              title: 'Control Account', 
              field: 'ca_name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Deliverable', 
              field: 'deliverable_name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Work Package', 
              field: 'name',
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              }
            },
            { 
              title: 'Completed', 
              field: 'workpackage_status',
              lookup: {1:"Not Completed", 2: "Completed"},
              cellStyle: {
                borderRight: "1px solid #d4d4d4"
              }
            },
            { 
              title: 'Completion date', 
              field: 'completion_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
                width:150,
                maxWidth:150
              },
              headerStyle:{
                maxWidth:150,
                width:150,
              }
            },
            { 
              title: 'Due Date', 
              field: 'max_date',
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
                width:150,
                maxWidth:150
              },
              headerStyle:{
                maxWidth:150,
                width:150,
              }
            }
          ]}
         data={this.state.workpackages}
          actions={actionButtons}
        />

        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
        <CompletionDialog  workpackage={this.state.workpackageSelected} open={this.state.openCompletionDialog}  handleClose={this.handleClose} action={this.state.action}/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    completion: state.completion,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)((Completion));


// WEBPACK FOOTER //
// ./src/features/completion/Completion.js